/**
 * The sign-in page's figures.
 *
 * `retry: false` and a long `staleTime`, both because of where this is used: a
 * sign-in page that retries a failing request three times is a sign-in page
 * that takes a second longer to become usable, for a decoration. If it does not
 * arrive, the screen shows no figures and nothing looks broken.
 */

import { useQuery } from '@tanstack/react-query';
import { fetchImpact } from '../services/api/impact';
import type { Impact } from '../services/api/impact';

/** Matches the five minutes the API asks browsers to cache it for. */
const IMPACT_STALE_TIME_MS = 5 * 60 * 1000;

export function useImpact() {
  return useQuery<Impact>({
    queryKey: ['impact'],
    queryFn: fetchImpact,
    staleTime: IMPACT_STALE_TIME_MS,
    retry: false,
  });
}
